var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPainterPaintworks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2.75V10C0.25 10.2652 0.355357 10.5196 0.542893 10.7071C0.73043 10.8946 0.984784 11 1.25 11C1.51522 11 1.76957 10.8946 1.95711 10.7071C2.14464 10.5196 2.25 10.2652 2.25 10V7.75C2.25 7.55109 2.32902 7.36032 2.46967 7.21967C2.61032 7.07902 2.80109 7 3 7V7C3.19891 7 3.38968 7.07902 3.53033 7.21967C3.67098 7.36032 3.75 7.55109 3.75 7.75V8.375C3.75 8.60706 3.84219 8.82962 4.00628 8.99372C4.17038 9.15781 4.39294 9.25 4.625 9.25V9.25C4.85706 9.25 5.07962 9.15781 5.24372 8.99372C5.40781 8.82962 5.5 8.60706 5.5 8.375V8C5.5 7.73478 5.60536 7.48043 5.79289 7.29289C5.98043 7.10536 6.23478 7 6.5 7H6.6975C6.94478 7.0003 7.18831 6.93946 7.40639 6.82289C7.62448 6.70632 7.81036 6.53765 7.9475 6.33187L8 6.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10H7V15.25C7 15.3826 7.05268 15.5098 7.14645 15.6036C7.24021 15.6973 7.36739 15.75 7.5 15.75H9.25C9.38261 15.75 9.50979 15.6973 9.60355 15.6036C9.69732 15.5098 9.75 15.3826 9.75 15.25V10H10.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10H9.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10V9.17688C8.25033 8.97727 8.31039 8.78234 8.42244 8.61716C8.53449 8.45197 8.69341 8.3241 8.87875 8.25L15.1213 5.75C15.3066 5.6759 15.4655 5.54803 15.5776 5.38284C15.6896 5.21766 15.7497 5.02273 15.75 4.82312V3.5C15.75 3.23478 15.6446 2.98043 15.4571 2.79289C15.2696 2.60536 15.0152 2.5 14.75 2.5H14",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 0.25H3C2.44772 0.25 2 0.697715 2 1.25V3.75C2 4.30228 2.44772 4.75 3 4.75H13C13.5523 4.75 14 4.30228 14 3.75V1.25C14 0.697715 13.5523 0.25 13 0.25Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainterPaintworks);
export default __webpack_public_path__ + "static/media/painter-paint works.2b511f50.svg";
export { ForwardRef as ReactComponent };